import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOrganizationById } from 'store/actions/organization';

export default (id = '') => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (id?.length) dispatch(fetchOrganizationById(id));
  }, []);

  const { data, loading, error } = useSelector((state) => state.organization);
  return { isAuthenticated: data && !error, data: { ...data?.attributes, id: data?.id }, loading };
};
